"use strict";
/** V2 Output format from voice-commanding-workflow
 * The final output is IVoiceCommandResultV2
 * This helps in maintainig the order of commands, and allows multiple text annotations
 * Refer this design document for more details: https://microsoft.sharepoint.com/:w:/t/inConcert207/ERU5MsdfFINJrziotHihUL4BsI3newzCoubVo7iWKAmmTA?e=O4Xlqz
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionWhich = exports.SelectionType = exports.UtteranceRecognitionType = void 0;
/**
 * Enum representing types output from FrontDoor used as input to voice commanding workflow
 * Example:
 *  Final: “This is a test.”
 *  Partial/Hypothesis: “this”, “this is”, “this is a”, “this is a test”
 *  Partial/Fragment: “this”, “is a”, “test”
 * Refer this [design document](https://microsoft.sharepoint.com/:w:/t/MUIPlatform/EQoMo23qQHRBk827sHONmEEBtE9J9lmLvWKux6QDjbl6FQ?e=hnYKqJ) for more details.
 */
var UtteranceRecognitionType;
(function (UtteranceRecognitionType) {
    UtteranceRecognitionType["Final"] = "Final";
    UtteranceRecognitionType["Fragment"] = "Fragment";
    UtteranceRecognitionType["Hypothesis"] = "Hypothesis";
})(UtteranceRecognitionType = exports.UtteranceRecognitionType || (exports.UtteranceRecognitionType = {}));
/************* Start of - Parameter details ************/
// Note: For SelectionType and SelectionWhich the order means they have higher priority if found in a response
var SelectionType;
(function (SelectionType) {
    SelectionType["Paragraph"] = "paragraph";
    SelectionType["Sentence"] = "sentence";
    SelectionType["Character"] = "character";
    SelectionType["Word"] = "word";
    SelectionType["That"] = "that";
    SelectionType["This"] = "this";
    SelectionType["Table"] = "table";
    SelectionType["Row"] = "row";
    SelectionType["Column"] = "column";
    SelectionType["Cell"] = "cell";
})(SelectionType = exports.SelectionType || (exports.SelectionType = {}));
var SelectionWhich;
(function (SelectionWhich) {
    SelectionWhich["Next"] = "next";
    SelectionWhich["Last"] = "last";
    SelectionWhich["Previous"] = "previous";
    SelectionWhich["Current"] = "current";
    SelectionWhich["Left"] = "left";
    SelectionWhich["Right"] = "right";
    SelectionWhich["Above"] = "above";
    SelectionWhich["Below"] = "below";
    SelectionWhich["Start"] = "start";
    SelectionWhich["End"] = "end";
    SelectionWhich["Up"] = "up";
    SelectionWhich["Down"] = "down";
})(SelectionWhich = exports.SelectionWhich || (exports.SelectionWhich = {}));
//# sourceMappingURL=annotations-v2.js.map